import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TransferRequestForExternalDTTResponse } from "../types";
import { SyntheticEvent } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import { WarningOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";

interface OpenTransferPlatesDialogProps {
    open: boolean,
    data: TransferRequestForExternalDTTResponse[] | [],
    onClose: (event: SyntheticEvent) => void,
    onConfirm: () => void
}

const OpenTransferPlatesDialog = ({
    open,
    data,
    onClose,
    onConfirm
}: OpenTransferPlatesDialogProps) => {

    const t = useOperationTranslation();

    return (
        <>
            <Dialog open={open} scroll="paper" >
                <DialogTitle>
                    <WarningOutlined 
                        sx={{
                            color: '#C8017D',
                            marginRight: '17px',
                        }}
                    />
                </DialogTitle>
                
                <DialogContent >
                    <Stack direction={"column"} gap={3} >
                        <Box alignItems={"center"}>
                            {t('vehicleEntrance.openTransferPlates.modalBody1') + ":"}
                        </Box>
                        { data.map((d) => (
                            <Stack direction={"column"} gap={1}>
                                <Stack direction={"row"} gap={1} alignItems={"center"}>
                                    <Typography fontWeight={"bold"}>{"DTT:"}</Typography>
                                    {d.deliveryNoteNumber}
                                </Stack>
                                <Stack direction={"row"} gap={1} alignItems={"center"} ml={2}>
                                    <Typography fontWeight={"bold"}>{t('vehicleEntrance.vehicles') + ":"}</Typography>
                                    {d.plates.join(",")}
                                </Stack>
                            </Stack>
                            ))
                        }
                        <Box alignItems={"center"}>
                            {t('vehicleEntrance.openTransferPlates.modalBody2')}
                        </Box>
                    </Stack>
                </DialogContent>
                
                <DialogActions>
                    <Stack direction={{xs: "column", sm: "row"}} gap={1}>                 
                        <Button 
                            color="accent"
                            variant="contained"
                            onClick={onConfirm}
                        >
                            <Typography fontWeight={"bold"} variant="subtitle2" color="accent" lineHeight={0}>
                                {t('vehicleExit.status.confirmVehicle')}
                            </Typography>
                        </Button>

                        <Button
                            style={{ color: '#d12c93', backgroundColor: 'white' }}
                            onClick={onClose}
                        >
                            <Typography fontWeight={"bold"} variant="subtitle2" color="accent" lineHeight={0}>
                                {t('vehicleExit.status.cancelVehicle')}
                            </Typography>
                        </Button>                 
                    </Stack>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default OpenTransferPlatesDialog;